import { IInjectHeadersHttpClient } from '@segurosvoluntarios_vel/commons-services';
import { IdProducto } from 'src/app/pago/enums/IdProducto.enum';
import { environment } from 'src/environments/environment';

export const headerAzure: IInjectHeadersHttpClient[] = [
  {
    headers: [
      {
        name: environment.headerSuscripcionNombre,
        value: environment.headerSuscripcionValor,
      },
    ],
    alloweds: [environment.pagosApi],
  },
];

export const getProductNameHeader = (
  nombreProducto: string = IdProducto.PRODUCTO_UNKNOWN
) => {
  return {
    headers: { nombreProducto },
  };
};
